export default "__VITE_ASSET__DR3i4deE__"